export default "__VITE_ASSET__DI0bv4gH__"